import { Typography } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

import useStyles from './styles/GatewayTable.styles'

const GatewayRowDesktop = () => {
  const classes = useStyles()
  return (
    <div className={classes.tableRowSkeleton}>
      <div>
        <Typography variant="body1">
          <Skeleton animation="wave" className={classes.skeleton} />
        </Typography>
      </div>
      <div>
        <Typography variant="body1">
          <Skeleton animation="wave" className={classes.skeleton} />
        </Typography>
      </div>
      <div>
        <Typography variant="body1">
          <Skeleton animation="wave" className={classes.skeleton} />
        </Typography>
      </div>
      <div>
        <Typography variant="body1">
          <Skeleton animation="wave" className={classes.skeleton} />
        </Typography>
      </div>
    </div>
  )
}
export default GatewayRowDesktop
